import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet";

import AboutUs from "./AboutUs";
import OurFeatures from "./OurFeatures";

function Main() {
  return (
    <>
      <Helmet>
        <title>DamecaLV - Bun Venit</title>
        <meta
          name="DamecaLV"
          content="Un partener de incredere in afacerile de livrari en-gros"
        />
      </Helmet>
      <MainStyled>
        <AboutUs />
        <OurFeatures />
      </MainStyled>
    </>
  );
}

export const MainStyled = styled.main`
  max-width: 1000px;
  margin: 50px auto 0;

  @media (max-width: 500px) {
    max-width: 500px;
    padding: 10px;
  }
`;

export default Main;
